import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import hljs from "highlight.js";

const ScrollToTop = () => {
  // Extracts pathname property(key) from an object
  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
};

export default ScrollToTop;
export const nameInitial = (name) => {
  const parts = name.split(" ");
  if (parts.length < 2) return name; // return the original name if it's not in "Firstname Lastname" format

  const firstNameInitial = parts[0].charAt(0);
  const lastNameInitial = parts[1].charAt(0);

  return `${firstNameInitial}${lastNameInitial}`;
};
export const copyToClipboard = (value) => {
  // Copy deposit address to clipboard
  navigator.clipboard.writeText(value);
};
// utils.js
export function convertMBtoGB(mb) {
  return `${mb / 1024} GB`;
}
export const formatStorage = (bytes) => {
  if (bytes >= 1024 * 1024 * 1024) {
    return `${Math.round(bytes / (1024 * 1024 * 1024))} GB`;
  } else if (bytes >= 1024 * 1024) {
    return `${Math.round(bytes / (1024 * 1024))} MB`;
  } else if (bytes >= 1024) {
    return `${Math.round(bytes / 1024)} KB`;
  } else {
    return `${bytes} Bytes`;
  }
};

export const detectLanguage = (code) => {
  const result = hljs.highlightAuto(code);
  return result.language || "text"; // Default to "text" if no language is detected
};
export const scrollToBottom = () => {
  window.scrollTo({
    top: document.documentElement.scrollHeight * 2, // Multiply by 2 to ensure scrolling past the bottom
    behavior: "smooth",
  });
};
